/* eslint-disable prettier/prettier */
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
/**
 * This class is private. Singleton class for storing callback functions and executing them by id in later time. Used in the mobile apps.
 *
 * @singleton
 * @type {RM_CallbackRegistry}
 * @Class RM.CallbackRegistry
 * @static
 * @private
 */

import eventBus from '@researchmetrics/event-bus'

const eventTitles = {
  callbackRegistryDelegate: 'callback-registry-delegate',
  callbackRegistryResolve: 'callback-registry-resolve'
}

let defaultExport = ''
if(typeof(window) === "undefined"){
  // eslint-disable-next-line no-global-assign
  global.window = global
}
if(window && window.RM && typeof window.RM.CallbackRegistry === "object"){
  defaultExport = window.RM.CallbackRegistry
} else {
  const _callbackRegistryConstructor = function() {
    // eslint-disable-next-line prefer-const
    let _instance = null
    const _getInstance = function() {
      if (!_instance) {
        const isInFrame = (function() {
          try {
            return window.self !== window.top
          } catch (e) {
            return true
          }
        })()
        _instance = {
          eventBus: eventBus,
          eventTitles: eventTitles,
          registry: {},
          idCounter: 1001,
          generateGUID: function() {
            let strSource = ''
  
            strSource += new Date().getTime().toString(16)
            strSource += (new Date().getTimezoneOffset() + 12 * 60).toString(16)
  
            for (let counter0 = 0; counter0 < 5; counter0++) {
              strSource += parseInt(
                Math.random()
                  .toString()
                  .slice(2)
              ).toString(16)
            }
  
            return (
              '{' +
              strSource.slice(0, 8) +
              '-' +
              strSource.slice(8, 12) +
              '-' +
              strSource.slice(12, 16) +
              '-' +
              strSource.slice(16, 20) +
              '-' +
              strSource.slice(20, 32) +
              '}'
            ).toUpperCase()
          },
  
          /**
           * Register a function
           * @example
           * ```javascript
           *     (function (){
           *         var regid = RM.CallbackRegistry.register(this, function (){ console.log(arguments);  } );
           *
           *         RM.CallbackRegistry.execute(regid, "callback param1", "2");
           *     })();
           * ```
           * @private
           * @method register
           * @param {Object} context The context will be this for the callback
           * @param {Function} func The callback
           * @return {Number} Id in the registry. Use it to call the callback
           */
          register: function(context, func) {
            const id = this.idCounter++
            const _this = this
  
            this.registry[id] = {
              func: func,
              context: context
            }
            // to do - fix the documentation
            
            return new Promise(function(resolve, reject) {
              if (isInFrame) {
                // the platform bridge in the top window must handle requests from below
                /* console.log(
                  'Callback registry REGISTER SLAVE - will publish',
                  _this.eventTitles.platformBridgeDelegate
                ) */
                const requestGUID = _this.generateGUID()
                _this.registry[requestGUID] = id
  
                _this.eventBus.publish(
                  _this.eventTitles.callbackRegistryDelegate,
                  {
                    requestGUID: requestGUID
                  },
                  '*',
                  function(registeredID) {
                    /* console.log('Callback registry RESOLVE SLAVE REGISTERED') */
                    resolve(registeredID)
                  }
                )
              } else {
                /* console.log('Callback registry REGISTER MASTER') */
                resolve(id)
              }
            })
          },
          /**
           * Execute the callback. After execution the callback is evicted from the registry.
           * @method execute
           * @private
           * @param {Number} callbackId The id of the callback to be executed
           * @param {Object} param Parameter passed to the callback
           * @param {Object} param All following parameters are passed to the callback
           */
          execute: function() {
            // console.log('Callback registry EXECUTE', arguments)
            const id = arguments[0]
  
            const args = []
            for (let a = 1; a < arguments.length; a++) {
              args.push(arguments[a])
            }
  
            const callback = this.registry[id]
            callback.func.apply(callback.context, args)
  
            delete this.registry[id]
          },
          registerChildCallback: function(eventPayload, callback) {
            // eventPayload contains request guid
            // console.log('Callback registry REGISTER SLAVE CALLBACK', eventPayload)
            const requestGUID = eventPayload.requestGUID
            const id = this.idCounter++
            const _this = this
  
            this.registry[id] = {
              func: function() {
                // args - the result returned from NATIVE code
                const args = []
                for (const k in arguments) {
                  args.push(arguments[k])
                }
                _this.eventBus.publish(
                  _this.eventTitles.callbackRegistryResolve,
                  {
                    requestGUID: requestGUID,
                    arguments: args
                  }
                )
              },
              context: this
            }
  
            callback(id)
          },
          resolveDelegated: function(eventPayload) {
            // eventPayload contains request guid
            // console.log('Callback registry RESOLVE DELEGATED', eventPayload)
            const requestGUID = eventPayload.requestGUID
            if (typeof this.registry[requestGUID] !== 'undefined') {
              const that = this
              const args = [this.registry[requestGUID]]
              for (const k in eventPayload.arguments) {
                args.push(eventPayload.arguments[k])
              }
              this.execute.apply(that, args)
            }
          }
        }
  
        if (isInFrame) {
          // if in an inner iframe, the registry must listen for its callback request being resolved by the top
          eventBus.subscribe(
            eventTitles.callbackRegistryResolve,
            _instance.resolveDelegated.bind(_instance),
            '*'
          )
        } else {
          // the platform bridge in the top window must handle requests from below
          eventBus.subscribe(
            eventTitles.callbackRegistryDelegate,
            _instance.registerChildCallback.bind(_instance),
            '*'
          )
        }
  
        if (typeof window.RM !== 'object') {
          window.RM = {}
        }
        if (typeof window.RM.CallbackRegistry !== 'object') {
          window.RM.CallbackRegistry = _instance
        }
      }
      return _instance
    }
  
    return _getInstance()
  }

  defaultExport = new _callbackRegistryConstructor()
}

export default defaultExport
